import { useTranslation } from '@mint-lib/i18n';
import { Button } from '@mint-lib/tw-components';

import { useCustomMetricsDrawer } from '../../contexts/CustomMetricsContext.jsx';

// Legacy custom metrics management, not available in Import Hub v2
export const ManageCustomMetricsButton = ({
  hasOptions,
}: {
  hasOptions: boolean;
}) => {
  const { t } = useTranslation('@myn/import-hub');
  const { openDrawer } = useCustomMetricsDrawer();

  return (
    <Button
      onClick={openDrawer}
      variant="plain"
      size="large"
      className="ml-auto"
      data-dd-action-name={'Manage custom metrics'}
    >
      {hasOptions ? t('Manage') : t('Create custom metric')}
    </Button>
  );
};
